// extracted by mini-css-extract-plugin
export default {"root":"MembershipBadge_root__7EV5k","free":"MembershipBadge_free__HS9F2","premium":"MembershipBadge_premium__fgMns"};